module.exports = __webpack_public_path__ + "images/thomas-brooke@2x.3c6ced4c13369096a89a6664b6ead30b.jpeg";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/images/team/thomas-brooke@2x.jpeg
// module id = 1031
// module chunks = 0